export const TYPES_QUIZ = {
  GET_QUIZ: 'GET_QUIZ',
  GET_QUIZ_LOADING: 'GET_QUIZ_LOADING',
  POST_QUIZ_ASSESSMENT: 'POST_QUIZ_ASSESSMENT',
  POST_QUIZ_ASSESSMENT_LOADING: 'POST_QUIZ_ASSESSMENT_LOADING',
};
